/* eslint-disable @next/next/no-img-element */
/* eslint-disable max-len */
import React, { useState } from "react";
import styles from "./styles.module.css";
import commonStyles from "../../../styles/commonStyles.module.css";
import { useTranslation } from "next-i18next/pages";
import Image from "next/image";
const AdminTask: React.FC = () => {
  const {
    t
  } = useTranslation('common');
  const [active, setActive] = useState(0);
  const tasks = [{
    title: t('Teacher Dashboard'),
    desc: t('Effortlessly manage your teaching tasks. Stay organized and focused with easy access to essential tools and resources, eliminating the need to navigate multiple systems.')
  }, {
    title: t('Lesson Planner'),
    desc: t('Simplify lesson planning with our efficient Lesson Planner. Save time creating and managing lesson plans, empowering you to deliver quality education without the administrative burden.')
  }, {
    title: t('Deliver On Any Devices'),
    desc: t('Easily host video conferences, leave feedback, start discussions, send messages, and more. Let learners access courses from anywhere, whether a desktop, laptop, tablet or mobile.')
  }];
  const getStyle = () => {
    switch (active) {
      case 0:
        return styles.listTask1;
      case 1:
        return styles.listTask2;
      case 2:
        return styles.listTask3;
      default:
        break;
    }
  };
  return <div className={styles.adminTaskContainer}>
      <div className={commonStyles.container}>
        <div className={styles.title}>{t('Simplify admin tasks to get back your precious time')}</div>
        <div className={styles.buttons}>
          {tasks.map((task, index) => <div key={index} onClick={() => setActive(index)} className={`${commonStyles.buttonNoBorder} ${active === index ? styles.active : ''}`}>
                {task.title}
              </div>)}
        </div>
        <div className={`${styles.listTask} ${getStyle()}`}>
          {tasks.map((task, index) => <span key={index} className={index === active ? `${styles.taskItem} ${styles.taskActive}` : styles.taskItem}>
                <section>
                  <div className={styles.taskTitle}>
                    {task.title}
                  </div>
                  <div className={styles.taskDesc}>
                    {task.desc}
                  </div>
                </section>
                <div className={styles.img}>
                  <Image width={483} height={476} alt="task" src={`/v3/tasks/${index + 1}.svg`} />
                </div>
              </span>)}
          <div className={styles.circle}>
            <div style={{
            position: 'relative',
            height: '100%'
          }}>
              <Image src="/v3/tasks/circle.svg" alt="bg" layout="fill" objectFit="cover" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AdminTask;